
   <!-- Search --> 
  <div class="row">
    <div class="col">
      <form [formGroup]="searchFilterForm" class="d-flex mb-3 px-1">
        <input formControlName="searchFilterField" class="form-control bar" type="search" placeholder="Cerca..." aria-label="Search">
        <button type="submit" class="bordersearch" (click)="clickSearch()"><i class="far fa-search grey"></i></button>
      </form>
    </div>
  </div>

  <!--Immagini-->
  <div class="row row-cols-1 row-cols-md-6 px-1">
    <div  class="col-lg-12 col-md-12 col-sm-12 col-xs-12" 
          *ngIf = "imageListFirstsearch"
          [hidden]="imagesList.length == 0?false:true">
      <p class="text-center">
        Non ci sono immagini
      </p>
    </div>

    <div style="height: 100%;" id="{{image.id}}" class="img-container m-1 search-results" 
    infinite-scroll
    [infiniteScrollUpDistance]="9"
    [infiniteScrollThrottle]="50"
    [infiniteScrollDisabled]="busyGettingData"
    (scrolled)="onScrollDown()"
    [scrollWindow]="true"
    *ngFor="let image of imagesList; index as i">

        <img *ngIf="image.published"
        appImageLoader
        loader="/assets/images/spinner/iphone-spinner-1.gif"
        onErrorSrc="/assets/images/no-image-icon.png"
            [src]="image.url"
            alt="{{image.name}}" 
            class="image">

        <img *ngIf="!image.published"
            [src]="image.url"
            alt="{{image.name}}" 
            class="image">
      
      <div class="content">
        <span class="text">{{image.name}}</span>
      </div>
      <div class="overlay">
          <a  title="Pubblica" [hidden]="image.published" class="" (click)="clickButtonPublishImage(image,true)"><i class="fas fa-eye"></i> </a>
          <a  title="DePubblica" [hidden]="!image.published" class="" (click)="clickButtonPublishImage(image,false)"><i class="fas fa-eye-slash"></i> </a>
          <a  title="Crop" class="" (click)="clickButtonCropImage(image.id)"><i class="fas fa-crop"></i> </a>
          <a  title="Modifica" class="" (click)="clickButtonUpdateImage(image.id)"><i class="fas fa-pencil"></i> </a>
          <a  title="Cancella" class="" (click)="clickButtonDeleteImage(image.id)"><i class="fas fa-trash"></i></a>
      </div>
    </div>
  </div>


  <!-- FloatingBar-->
  <app-floatingbar [toggleParam]="true" [toggleParam]="true" [items]="menuItems" (choiceButton)="choiceButtonResponse($event)"></app-floatingbar>
     